// jshint esversion: 8
const setUser = ({ commit }, payload) => {
  for (var key in payload) {
    if (payload.hasOwnProperty(key)) {
      if (key === 'user') {
        commit('SET_USERNAME', payload[key].username)
        commit('SET_FIRST_NAME', payload[key].first_name)
        commit('SET_LAST_NAME', payload[key].last_name)
        commit('SET_EMAIL', payload[key].email)
      } else {
        commit(`SET_${key.toUpperCase()}`, payload[key])
      }
    }
  }
}
const clearUser = ({ commit }) => {
  const keys = ['username', 'first_name', 'last_name', 'email', 'id', 'image', 'department', 'location']
  for (var i = 0; i < keys.length; i++) {
    let key = keys[i]
    commit(`SET_${key.toUpperCase()}`, null)
  }
}
export default {
  setUser,
  clearUser
}
